import React from 'react';

import {Stack} from "@mui/material";
import {statisticNavigate} from "./constants";
import Item from './item/Item'
import {sx} from './sx'

const NavigateStatistic = () => {

    const list = statisticNavigate.map((item) => {
        return (
            <Item {...item} key={item.path}/>
        )
    })

    return (
        <Stack
            sx={sx.root}
            gap={1}
        >
            {list}
        </Stack>
    );
};

export default NavigateStatistic;